import { Reveal, Eyebrow } from "@/components/Reveal";
import { TestimonialCard } from "@/components/TestimonialCard";
import { useTestimonials } from "@/hooks/useData";

export const Testimonials = () => {
  const { data: testimonials = [] } = useTestimonials("?featured=true");
  const lead = testimonials[0];
  const rest = testimonials.slice(1, 4);
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-32" data-testid="testimonials-section">
      <div className="text-center max-w-3xl mx-auto">
        <Eyebrow>Client Voices</Eyebrow>
        {lead && (
          <Reveal>
            <blockquote className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight text-[#2C2A29] mt-6 italic">
              “{lead.quote}”
            </blockquote>
            <p className="mt-8 label-eyebrow text-[11px] text-[#9E8773]">
              {lead.author_name} — {lead.author_title}
            </p>
          </Reveal>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-16">
        {rest.map((t, i) => (
          <Reveal key={t.id} delay={i * 0.08}>
            <TestimonialCard t={t} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
